var Shopify = Shopify || {};
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

if (!customElements.get('sticky-atc')) {
  class stickyAtc extends HTMLElement {
    constructor() {
      super();

      if (this.dataset.discontinued === 'true') return;

      this.mainHeader = document.querySelector('#shopify-section-header');
      this.mainATCWrapper = document.querySelector('.product--button-wrapper');
      if (!this.mainATCWrapper) return;

      this.mainATC = this.mainATCWrapper.querySelector('.ProductForm__AddToCart');
      this.mainQuantityInput = document.querySelector('.ProductForm .QuantitySelector__CurrentQuantity');
      this.variantJson = JSON.parse(this.querySelector('[data-variant-json]').textContent);
      this.atcBtn = this.querySelector('[data-atc]');
      this.priceEl = this.querySelector('[data-sticky-price]');
      this.qtyInput = this.querySelector('[data-qty-input]');
      this.qtyMinus = this.querySelector('[data-qty-minus]');
      this.qtyPlus = this.querySelector('[data-qty-plus]');
      this.isCfp = this.dataset.cfp === 'true';
      this.isDiscontinued = false;

      this.init();
    }

    onVariantChange = () => {
      document.addEventListener('variant:changed', (e) => {
        const variant = e.detail.variant;
        if (!variant) return;

        this.checkDiscontinued(variant);

        if (this.isCfp) return;

        this.updatePrice(variant);

        if (this.atcBtn) {
          if (variant.available) {
            this.atcBtn.textContent = 'ADD TO CART';
            this.atcBtn.disabled = false;
          } else {
            this.atcBtn.textContent = 'SOLD OUT';
            this.atcBtn.disabled = true;
          }
        }
      });
    }

    checkDiscontinued(variant) {
      const jsonEl = document.querySelector('[data-variants-discontinued-json]');
      if (!jsonEl) return;
      try {
        const discontinuedMap = JSON.parse(jsonEl.textContent);
        if (discontinuedMap[variant.id]?.discontinued) {
          this.isDiscontinued = true;
          this.classList.remove('active');
        } else {
          this.isDiscontinued = false;
        }
      } catch (e) {
        // ignore malformed discontinued variant data.
      }
    }

    updatePrice(variant) {
      if (!this.priceEl) return;
      const price = Shopify.formatMoney(variant.price, window.theme?.moneyFormat);
      const compareAt = variant.compare_at_price;

      if (compareAt && compareAt > variant.price) {
        const comparePrice = Shopify.formatMoney(compareAt, window.theme?.moneyFormat);
        this.priceEl.innerHTML =
          `<span class="sticky-atc-bar__price--sale">${price}</span>` +
          `<span class="sticky-atc-bar__price--compare">${comparePrice}</span>`;
      } else {
        this.priceEl.innerHTML =
          `<span class="sticky-atc-bar__price--regular">${price}</span>`;
      }
    }

    // show after the main atc clears the sticky header.
    toggleStickyBar = () => {
      const update = () => {
        if (!this.mainATCWrapper || this.isDiscontinued) {
          this.classList.remove('active');
          return;
        }
        const headerHeight = this.mainHeader ? this.mainHeader.clientHeight : 0;
        const atcRect = this.mainATCWrapper.getBoundingClientRect();
        const isActive = this.classList.contains('active');
        const threshold = isActive ? headerHeight + 4 : headerHeight - 4;
        const scrolledPastHero = atcRect.bottom <= threshold;
        this.classList.toggle('active', scrolledPastHero);
      };

      // batch scroll updates into animation frames.
      let ticking = false;
      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => { update(); ticking = false; });
          ticking = true;
        }
      });

      window.addEventListener('resize', update);
      window.addEventListener('DOMContentLoaded', update);
      update();
    }

    handleATC = () => {
      if (!this.atcBtn || !this.mainATC) return;
      this.atcBtn.addEventListener('click', () => {
        if (this.qtyInput && this.mainQuantityInput) {
          this.mainQuantityInput.value = this.qtyInput.value;
          this.mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.mainATC.click();
      });
    }

    handleQty = () => {
      if (!this.qtyInput) return;

      if (this.qtyMinus) {
        this.qtyMinus.addEventListener('click', () => {
          let val = parseInt(this.qtyInput.value) || 1;
          if (val > 1) val--;
          this.qtyInput.value = val;
          this.syncQtyToMain(val);
        });
      }
      if (this.qtyPlus) {
        this.qtyPlus.addEventListener('click', () => {
          let val = parseInt(this.qtyInput.value) || 1;
          if (val < 99) val++;
          this.qtyInput.value = val;
          this.syncQtyToMain(val);
        });
      }

      this.qtyInput.addEventListener('change', () => {
        let val = parseInt(this.qtyInput.value) || 1;
        val = Math.max(1, Math.min(99, val));
        this.qtyInput.value = val;
        this.syncQtyToMain(val);
      });

      if (this.mainQuantityInput) {
        const mainQtyObserver = new MutationObserver(() => {
          const mainVal = parseInt(this.mainQuantityInput.value) || 1;
          if (parseInt(this.qtyInput.value) !== mainVal) {
            this.qtyInput.value = mainVal;
          }
        });
        mainQtyObserver.observe(this.mainQuantityInput, { attributes: true, attributeFilter: ['value'] });

        this.mainQuantityInput.addEventListener('change', () => {
          const mainVal = parseInt(this.mainQuantityInput.value) || 1;
          this.qtyInput.value = mainVal;
        });

        // buttons do not always emit a quantity change event.
        const mainMinus = document.querySelector('.ProductForm .QuantitySelector [data-action="decrease-quantity"]');
        const mainPlus = document.querySelector('.ProductForm .QuantitySelector [data-action="increase-quantity"]');
        if (mainMinus) {
          mainMinus.addEventListener('click', () => {
            setTimeout(() => {
              this.qtyInput.value = this.mainQuantityInput.value;
            }, 50);
          });
        }
        if (mainPlus) {
          mainPlus.addEventListener('click', () => {
            setTimeout(() => {
              this.qtyInput.value = this.mainQuantityInput.value;
            }, 50);
          });
        }
      }
    }

    syncQtyToMain(val) {
      if (!this.mainQuantityInput) return;
      this.mainQuantityInput.value = val;
      this.mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    init = () => {
      this.onVariantChange();
      this.toggleStickyBar();
      this.handleATC();
      this.handleQty();
    }
  }
  customElements.define('sticky-atc', stickyAtc);
}
